/**
 * @module components/text-field
 */
import { Component } from '@roskvartal-landings/base';

/**
 * @extends module:common/classes/component~Component
 * @inheritdoc
 * @classdesc Компонент текстового поля
 */
class TextField extends Component {
  /**
   * @param {HTMLElement} el - Корневой элемент компоненты
   */
  constructor(el) {
    super(el);
    const data = {
      value: null,
      isDirty: false,
      gapWidth: null,
    };
    /**
     * @member {Object}
     * @property {String} value - Значение поля ввода
     * @property {Boolean} isDirty - Было ли затронуто поле ввода
     * @property {Number} gapWidth - Ширина "прорези" для лейбла
     */
    this.data = new Proxy(data, this.dataProxyHandlers);
    this.init();
  }

  /**
   * @method
   * @description Инициализация компоненты
   */
  init() {
    const control = this.refs.get('control');
    this.data.value = control.value;
    if (this.data.value) {
      if (!this.data.gapWidth) {
        this.countGapSize();
      }
      this.data.isDirty = true;
    }
    this.addEventListeners();
  }

  /**
   * @method
   * @description Добавляет слушатели событий на элементы
   */
  addEventListeners() {
    const control = this.refs.get('control');
    const notch = this.refs.get('notch');
    control.addEventListener('focus', () => {
      this.data.isDirty = false;
      if (!this.data.gapWidth) {
        this.countGapSize();
      }
      notch.style.width = this.data.gapWidth;
    });
    control.addEventListener('blur', () => {
      if (this.data.value) this.data.isDirty = true;
      else notch.style.width = 'auto';
    });
    control.addEventListener('input', () => {
      this.data.value = control.value;
      control.classList.remove('is-invalid');
    });
    control.addEventListener('change', () => {
      this.data.value = control.value;
      control.classList.remove('is-invalid');
    });
  }

  /**
   * @method
   * @description Рассчитывает размер отступа для лейбла
   */
  countGapSize() {
    const label = this.refs.get('label');
    const { width } = label.getBoundingClientRect();
    this.data.gapWidth = `${width * 0.875}px`;
  }

  /**
   * @readonly
   * @member {Object}
   * @description Ловушки для {@link module:components/text-field~TextField#data}
   */
  get dataProxyHandlers() {
    const control = this.refs.get('control');
    const dataProxyHandlers = {
      set: (obj, prop, val) => {
        if (prop === 'isDirty') {
          if (val) control.classList.add('is-dirty');
          else control.classList.remove('is-dirty');
        }
        return Reflect.set(obj, prop, val);
      },
    };
    return dataProxyHandlers;
  }
}

export default TextField;
